import React, { useEffect, useState } from "react";

import "./update_details_modal.less";
import { TooltipRenderer } from "@src/custom_renderer";
import { columnTypes } from "@src/utils/aggrid_utils";
import { AgGridReact } from "ag-grid-react";
import { Modal } from "antd";
import _ from "lodash";
import dayjs from "dayjs";

export default function UpdateDetailsModal({
  setModalVisible,
  modalVisible,
  openedDetailsSapDTO,
}) {
  const [rowData, setRowData] = useState([]);
  const gridApi = React.useRef(null);

  const columnDefs = [
    { field: "attributeName", width: 205 },
    { field: "oldValue", width: 250, cellRenderer: "valueRenderer" },
    { field: "newValue", width: 250, cellRenderer: "valueRenderer" },
  ];

  const frameworkComponents = {
    valueRenderer: (props) => {
      if (
        props.value &&
        (props.data.attributeName === "position start date" ||
          props.data.attributeName === "position end date")
      ) {
        return TooltipRenderer(dayjs(props.value).format("YYYY-MM-DD"));
      }

      return TooltipRenderer(props.value);
    },
  };

  const gridOptions = {
    suppressRowClickSelection: true,
    rowHeight: 60,
    domLayout: "autoHeight",
    defaultColDef: {
      ...columnTypes.default,
      sortable: false,
      resizeable: false,
    },
  };

  useEffect(() => {
    setRowData(_.cloneDeep(openedDetailsSapDTO.data.oldValues));
  }, [openedDetailsSapDTO]);

  return (
    <Modal
      width="755px"
      open={modalVisible}
      centered
      title="Updated data overview"
      closable={false}
      maskClosable={false}
      bodyStyle={{ width: "100%" }}
      onCancel={() => setModalVisible(false)}
      okButtonProps={{ style: { display: "none" } }}
    >
      <div className="sap-update-details-table">
        <AgGridReact
          rowData={rowData}
          components={frameworkComponents}
          gridOptions={gridOptions}
          columnDefs={columnDefs}
          onGridReady={(params) => (gridApi.current = params.api)}
        />
      </div>
    </Modal>
  );
}
